import { render, staticRenderFns } from "./CorporateStats.vue?vue&type=template&id=6dac6c9a&scoped=true&"
import script from "./CorporateStats.vue?vue&type=script&setup=true&lang=js&"
export * from "./CorporateStats.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac6c9a",
  null
  
)

export default component.exports